import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
const HolidaysHomework = () => {
  useEffect(() => {
    document.title =
      "Curriculum Extension Activities -  St Peters convent School Faridabad Haryana";
  }, []);
  return (
    <>
      <Header />
      <div className="innerslide">
        <ul className="breadcrumb">
          <li>
            <Link to="/"> Home</Link>
          </li>
          <li> Academics </li>
          <li>Curriculum Extension Activities </li>
        </ul>
      </div>
      <div className="innersec">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1>Curriculum Extension Activities </h1>
            </div>
          </div>
          <div className="row" id="homeworktabsec">
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-4">
                  <select className="form-control">
                    <option>2025</option>
                  </select>
                </div>
              </div>
              <nav>
                <div
                  class="nav nav-tabs homeworktab"
                  id="nav-season-tab"
                  role="tablist"
                >
                  <button
                    class="nav-link active"
                    id="summer-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#summer"
                    type="button"
                    role="tab"
                    aria-controls="summer"
                    aria-selected="true"
                  >
                    Summer Break Activities
                  </button>
                  <button
                    class="nav-link"
                    id="winter-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#winter"
                    type="button"
                    role="tab"
                    aria-controls="winter"
                    aria-selected="false"
                  >
                    Winter Break Activities
                  </button>
                </div>
              </nav>
              <div class="tab-content" id="nav-season-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="summer"
                  role="tabpanel"
                  aria-labelledby="summer-tab"
                >
                  {/* <div className="row">
                    <div className="col-lg-4">
                      <select className="form-control">
                        <option>2025</option>
                      </select>
                    </div>
                  </div> */}
                  <nav>
                    <div
                      class="nav nav-tabs homeworktab"
                      id="nav-summer-tab"
                      role="tablist"
                    >
                      <button
                        class="nav-link active"
                        id="summer-academics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#summer-academics"
                        type="button"
                        role="tab"
                        aria-controls="summer-academics"
                        aria-selected="true"
                      >
                        Academics
                      </button>
                      <button
                        class="nav-link"
                        id="summer-robotics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#summer-robotics"
                        type="button"
                        role="tab"
                        aria-controls="summer-robotics"
                        aria-selected="false"
                      >
                        Robitics
                      </button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-summer-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="summer-academics"
                      role="tabpanel"
                      aria-labelledby="summer-academics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Nurseryhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Nursery</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/LKGhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> LKG</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/UKGhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> UKG</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class I</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class II</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIIIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class III</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIVhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class IV</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class V</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VI</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classVIIIhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VIII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classIXhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class IX</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/classXhomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class X</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="summer-robotics"
                      role="tabpanel"
                      aria-labelledby="summer-robotics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/RoboticsHolidayHomework.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Robotics</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="tab-pane fade"
                  id="winter"
                  role="tabpanel"
                  aria-labelledby="winter-tab"
                >
                  <nav>
                    <div
                      class="nav nav-tabs homeworktab"
                      id="nav-winter-tab"
                      role="tablist"
                    >
                      <button
                        class="nav-link active"
                        id="winter-academics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#winter-academics"
                        type="button"
                        role="tab"
                        aria-controls="winter-academics"
                        aria-selected="true"
                      >
                        Academics
                      </button>
                      <button
                        class="nav-link"
                        id="winter-robotics-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#winter-robotics"
                        type="button"
                        role="tab"
                        aria-controls="winter-robotics"
                        aria-selected="false"
                      >
                        Robitics
                      </button>
                    </div>
                  </nav>
                  <div class="tab-content" id="nav-winter-tabContent">
                    <div
                      class="tab-pane fade show active"
                      id="winter-academics"
                      role="tabpanel"
                      aria-labelledby="winter-academics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_winter_break_NURSERY.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Nursery</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_Break_LKG.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> LKG</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Winter_Break_Class_1.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class I</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/WINTER_BREAK_class_2.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class II</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_Break_class_4.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class IV</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_Winter_break _class_5.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class V</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/ACTIVITIES_WINTER_BREAK_class_6.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VI</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_wnter_break_class_7.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                        <div className="col-lg-4">
                          <a
                            href="https://webapi.entab.info/api/image/STPSFH/public/pdf/Activities_winter_break_class_8.pdf"
                            target="_blank"
                          >
                            <div class="sample-blk">
                              <div>
                                <p> Class VIII</p>
                              </div>
                              <LazyLoad>
                                <img
                                  alt="STPCH"
                                  src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/STPSFH/public/Images/pdf.png"
                                  class="img-fluid"
                                />
                              </LazyLoad>
                            </div>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="winter-robotics"
                      role="tabpanel"
                      aria-labelledby="winter-robotics-tab"
                    >
                      <div className="row">
                        <div className="col-lg-12">
                          <p>No content available.</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default HolidaysHomework;
